var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"c-loading-box",style:({ background: _vm.loading ? _vm.background : 'transparent', loading: _vm.loading })},[(_vm.empty)?_c('Empty'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }